export default __webpack_public_path__ + "static/NotoSans-Italic.subset-3ae2159c54da6b93876ede667425365d.woff";